import { IDisciplinaObrigatoriaData } from '@/@types/Graduacao/DisciplinasObrigatorias';

interface ItemSemestreDisciplinasObrigatoriasProps {
    semestre: number;
    data: IDisciplinaObrigatoriaData[];
}

/**
 * Componente para exibir as disciplinas obrigatórias de um semestre.
 * @param semestre Número do semestre
 * @param data Dados das disciplinas obrigatórias
 * @returns Componente de disciplinas obrigatórias para um semestre específico
 */

const ItemSemestreDisciplinasObrigatorias = ({ semestre, data }: ItemSemestreDisciplinasObrigatoriasProps) => {
    return (
        <div className='mb-[10px]'>
            {semestre < 0 && 0}{semestre}° Semestre ==&gt; &nbsp;

            {data.map((subject, index) => {
                if (subject.DISC_SERVICO == 0 && subject.PERIODO == semestre) {
                    return (
                        <span key={index}>
                            <a className='font-bold text-colorSecondary hover:underline' target='_blank' href={subject.ano_catal <= 2020 ? subject.URL2020 : subject.URL2021}>{subject.COD_DISC}</a>
                            <span> ({subject.NUM_CRED_DISCI}), </span>
                        </span>
                    );
                }
            })}

            {data.map((subject, index) => {
                if (subject.DISC_SERVICO == 1 && subject.PERIODO == semestre) {
                    return (
                        <span key={index}>
                            &nbsp;
                            &nbsp;
                            <a className='font-bold hover:underline hover:text-colorPrimary' target='_blank' href={subject.ano_catal <= 2020 ? subject.URL2020 : subject.URL2021}>{subject.COD_DISC}</a>
                        </span>
                    )
                }
            })}

        </div>
    );
}

export { ItemSemestreDisciplinasObrigatorias };